module.exports = __webpack_public_path__ + "static/media/currency_setup.67f1df4a.svg";